import { render, staticRenderFns } from "./SidekickSearch.vue?vue&type=template&id=0f45cf77&scoped=true&"
import script from "./SidekickSearch.vue?vue&type=script&lang=js&"
export * from "./SidekickSearch.vue?vue&type=script&lang=js&"
import style0 from "./SidekickSearch.vue?vue&type=style&index=0&id=0f45cf77&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f45cf77",
  null
  
)

export default component.exports